/**
 * @generated SignedSource<<9483ad588e0a750883f89a19be2d7afc>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ticket",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UserInvitationModal_createUserInvitationMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CreateUserInvitationPayload",
                    "kind": "LinkedField",
                    "name": "createUserInvitation",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfUserInvitation",
                            "kind": "LinkedField",
                            "name": "invitationEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UserInvitation",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UserInvitationModal_createUserInvitationMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CreateUserInvitationPayload",
                    "kind": "LinkedField",
                    "name": "createUserInvitation",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfUserInvitation",
                            "kind": "LinkedField",
                            "name": "invitationEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UserInvitation",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "id",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "09ed4f4b7e00268b0a327e5503564783",
            "id": null,
            "metadata": {},
            "name": "UserInvitationModal_createUserInvitationMutation",
            "operationKind": "mutation",
            "text": "mutation UserInvitationModal_createUserInvitationMutation(\n  $model: InviteUserRequestInput!\n) {\n  createUserInvitation(model: $model) {\n    invitationEdge {\n      node {\n        ticket\n        id\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "df3165e19d3a4b56727c0626009a6a3d";
export default node;
